import { defineRoute } from '../defineRoute';

export type SafetyTenantRouteParams = {
  // ...
};

export type SafetyTenantRouteParamsString = {
  // ...
};

export const SafetyTenant = defineRoute<
  SafetyTenantRouteParams,
  SafetyTenantRouteParamsString
>({
  pathname: '/safety-tenant',
  nlPathname: '/veiligheid-huurder',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
